__webpack_require__.p = "/mi-assets/mi-static/mi-luxury-renderer/web-rel-26.8.1-e3f089a-14120/_next/";